import { useState } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  TriggerSectionTitle,
  TriggerSectionSubtitle,
} from '../AssistantScriptDialog.styled';
import {
  PlaybackSection,
  PolicyDropdown,
  PolicyDropdownHeader,
  PolicyDropdownItem,
  PolicyBadge,
  PolicyHeaderRow,
  PolicyNameRow,
  PolicyIcon,
  PolicyName,
  PolicyHeaderDesc,
  PolicyItemDesc,
  PolicyItemContent,
  PolicyRadioOuter,
  PolicyRadioInner,
  PolicyExpandIcon,
} from './styled';
import { PlaybackPolicySectionProps } from './interfaces';
import { POLICIES } from './constants';

const PlaybackPolicySection = ({
  playbackPolicy,
  onPlaybackPolicyChange,
  skipFirstSession,
  onSkipFirstSessionChange,
}: PlaybackPolicySectionProps) => {
  void skipFirstSession;
  void onSkipFirstSessionChange;

  const { t } = useTranslation('common');
  const [open, setOpen] = useState(false);

  const selected = POLICIES.find((p) => p.id === playbackPolicy) ?? POLICIES[1];

  return (
    <PlaybackSection>
      <TriggerSectionTitle>{t('assistant.scriptDialog.playbackPolicy')}</TriggerSectionTitle>
      <TriggerSectionSubtitle>
        {t('assistant.scriptDialog.playbackPolicySubtitle')}
      </TriggerSectionSubtitle>

      <PolicyDropdown $open={open}>
        <PolicyDropdownHeader
          $open={open}
          onClick={() => setOpen(!open)}
        >
          <PolicyHeaderRow>
            <PolicyIcon>{selected.icon}</PolicyIcon>
            <Box>
              <PolicyNameRow>
                <PolicyName>
                  {t(`assistant.scriptDialog.policies.${selected.id}.name`)}
                </PolicyName>
                {selected.badge && (
                  <PolicyBadge>
                    {t(`assistant.scriptDialog.policies.${selected.id}.badge`)}
                  </PolicyBadge>
                )}
              </PolicyNameRow>
              <PolicyHeaderDesc>
                {t(`assistant.scriptDialog.policies.${selected.id}.desc`)}
              </PolicyHeaderDesc>
            </Box>
          </PolicyHeaderRow>
          <PolicyExpandIcon $open={open} />
        </PolicyDropdownHeader>

        {open &&
          POLICIES.map((p, i) => {
            const isSelected = playbackPolicy === p.id;
            return (
              <PolicyDropdownItem
                key={p.id}
                $isSelected={isSelected}
                $isLast={i === POLICIES.length - 1}
                onClick={() => {
                  onPlaybackPolicyChange(p.id);
                  setOpen(false);
                }}
              >
                <PolicyIcon>{p.icon}</PolicyIcon>
                <PolicyItemContent>
                  <PolicyNameRow>
                    <PolicyName>
                      {t(`assistant.scriptDialog.policies.${p.id}.name`)}
                    </PolicyName>
                    {p.badge && (
                      <PolicyBadge>
                        {t(`assistant.scriptDialog.policies.${p.id}.badge`)}
                      </PolicyBadge>
                    )}
                  </PolicyNameRow>
                  <PolicyItemDesc>
                    {t(`assistant.scriptDialog.policies.${p.id}.desc`)}
                  </PolicyItemDesc>
                </PolicyItemContent>
                <PolicyRadioOuter $isSelected={isSelected}>
                  {isSelected && <PolicyRadioInner />}
                </PolicyRadioOuter>
              </PolicyDropdownItem>
            );
          })}
      </PolicyDropdown>
    </PlaybackSection>
  );
};

export default PlaybackPolicySection;
